const i18n = {
  'en-US': {
    'forgot.form.title': 'Forgot password',
    'forgot.form.subtitle': 'Reset password by phone or email',
    'forgot.form.identifier.errMsg': 'Account must be a phone or email',
    'forgot.form.verifyCode.errMsg': 'Verify code must be 6 digits',
    'forgot.form.getVerifyCode.errMsg': 'Get verify code error, please refresh and try again',
    'forgot.form.password.errMsg': 'Password cannot be empty',
    'forgot.form.resetPassword.errMsg': 'Reset password error, please refresh and try again',
    'forgot.form.identifier.placeholder': 'Please enter phone or email',
    'forgot.form.verifyCode.placeholder': 'Verify code',
    'forgot.form.getVerifyCode': 'Get verify code',
    'forgot.form.password.placeholder': 'Please enter password',
    'forgot.form.confirmPassword.placeholder': 'Please confirm password',
    'forgot.form.confirmPassword.errMsg': 'Passwords do not match',
    'forgot.form.login': 'Login',
    'forgot.form.resetPassword': 'Reset password'
  },
  'zh-CN': {
    'forgot.form.title': '忘记密码',
    'forgot.form.subtitle': '通过手机或者邮箱找回密码',
    'forgot.form.identifier.errMsg': '账号必须为手机号码或者邮箱地址',
    'forgot.form.verifyCode.errMsg': '验证码必须为6位数字',
    'forgot.form.getVerifyCode.errMsg': '获取验证码出错，请刷新重试',
    'forgot.form.password.errMsg': '密码不能为空',
    'forgot.form.resetPassword.errMsg': '重置密码出错，请刷新重试',
    'forgot.form.identifier.placeholder': '请输入手机号码或者邮箱地址',
    'forgot.form.verifyCode.placeholder': '请输入验证码',
    'forgot.form.getVerifyCode': '获取验证码',
    'forgot.form.password.placeholder': '请输入密码',
    'forgot.form.confirmPassword.placeholder': '请确认密码',
    'forgot.form.confirmPassword.errMsg': '两次输入密码不一致',
    'forgot.form.login': '登录',
    'forgot.form.resetPassword': '重置密码'
  }
};
export default i18n;